export default "__VITE_ASSET__CH$44nsI__"